import React, { useState, useEffect } from 'react';
import { Box, Typography, useTheme, Card, CardContent, Grid, Chip } from '@mui/material';
import { tokens } from '../../theme';
import { useParams, useNavigate } from "react-router-dom";
import useSessionTimeRangeService from '../../api/services/SessionTimeRangeService';
import LoadingSpinner from '../../components/LoadingSpinner';
import Header from "../../components/Header";
import DetailsBox from '../../components/DetailsBox';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';

const SessionTimeRange_Details = () => {
  const { id } = useParams();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const [sessionTimeRange, setSessionTimeRange] = useState(null);
  const [loading, setLoading] = useState(true);

  const { getSessionTimeRangeById } = useSessionTimeRangeService();

  useEffect(() => {
    const fetchDetails = async () => {
      if (id) {
        setLoading(true);
        try {
          const data = await getSessionTimeRangeById(id);
          setSessionTimeRange(data);
        } catch (error) {
          console.error('Error fetching session time range details:', error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleBack = () => {
    navigate('/session-time-ranges');
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!sessionTimeRange) {
    return (
      <Box sx={{ ml: '20px', mr: '20px' }}>
        <Typography variant="h6" color="error">
          Session time range not found
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ ml: '20px', mr: '20px' }}>
      <Box display="flex" alignItems="center" gap={2} mb={2}>
        <IconButton onClick={handleBack} color="primary">
          <ArrowBackIcon />
        </IconButton>
        <Header title="SESSION TIME RANGE DETAILS" />
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
                Basic Information
              </Typography>
              <DetailsBox
                label="Session Time"
                value={sessionTimeRange.sessionTime || 'N/A'}
              />
              <DetailsBox
                label="Time Description"
                value={sessionTimeRange.timeDescription || 'N/A'}
              />
              <Box mt={2}>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  Status
                </Typography>
                <Chip
                  label={sessionTimeRange.status || 'N/A'}
                  color={sessionTimeRange.status === 'ACTIVE' ? 'success' : 'default'}
                  sx={{ mt: 1 }}
                />
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
                Additional Information
              </Typography>
              <DetailsBox
                label="Created At"
                value={sessionTimeRange.createdAt ? new Date(sessionTimeRange.createdAt).toLocaleString() : 'N/A'}
              />
              <DetailsBox
                label="ID"
                value={sessionTimeRange.id || 'N/A'}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SessionTimeRange_Details;

